import { Translations } from './types';

export const es: Translations = {
  sidebar: {
    welcome: 'Bienvenido,',
    logout: 'Cerrar sesión',
    closeMenu: 'Cerrar menú',
    openMenu: 'Abrir menú',
    menuItems: {
      'Homepage': 'Inicio',
      'Bacheca': 'Tablón',
      'Eventi': 'Eventos',
      'Pubblicità': 'Publicidad',
      'Invia Messaggi': 'Enviar Mensajes',
      'Clienti': 'Clientes',
      'Matching': 'Matching',
      'Location': 'Ubicaciones',
      'Team': 'Equipo',
      'Contabilità': 'Contabilidad',
      'Agenzia Amore': 'Agencia de Amor',
      'Dating Coach': 'Coach de Citas',
      'Consulente d\'Immagine': 'Consultor de Imagen',
      'Messaggeria': 'Mensajeria',
      'Tavoli': 'Mesas',
      'Messaggi': 'Mensajes',
      'Consulenze': 'Consultas',
      'Corsi per Single': 'Cursos para Solteros',
      'Viaggi per Single': 'Viajes para Solteros',
      'Marketing': 'Marketing',
      'Altri Eventi': 'Otros Eventos',
      'Speed Date': 'Speed Date',
      'Gestione Staff': 'Gestion del Personal',
    },
  },
  profile: {
    tabs: {
      profile: 'Perfil',
      settings: 'Configuración',
      company: 'Empresa',
    },
    header: {
      name: 'Nombre',
      role: 'Rol',
      city: 'Ciudad',
      notDefined: 'No definida',
    },
    roles: {
      admin: 'Administrador',
      organizer: 'Organizador',
      pr: 'PR',
      collaboratore: 'Colaborador',
    },
    form: {
      name: 'Nombre',
      email: 'Email',
      phone: 'Número de Teléfono',
      city: 'Ciudad',
      emailReadonly: 'El email no se puede modificar',
      phonePlaceholder: '+34 612 345 678',
      cityPlaceholder: 'Introduce la ciudad',
      changePassword: 'Cambiar Contraseña',
      newPassword: 'Nueva Contraseña',
      confirmPassword: 'Confirmar Nueva Contraseña',
      newPasswordPlaceholder: 'Dejar vacío para no modificar',
      confirmPasswordPlaceholder: 'Repetir nueva contraseña',
      saving: 'Guardando...',
      save: 'Guardar Cambios',
    },
    settings: {
      notifications: 'Notificaciones',
      emailNotifications: 'Notificaciones por Email',
      pushNotifications: 'Notificaciones Push',
      eventReminders: 'Recordatorios de Eventos',
      security: 'Seguridad',
      twoFactor: 'Autenticación de Dos Factores',
      language: 'Idioma',
      languageDescription: 'Selecciona el idioma de la interfaz de administración',
    },
    company: {
      title: 'Perfil de la Empresa',
      companyName: 'Nombre de la Empresa',
      email: 'Email',
      phone: 'Teléfono',
    },
    messages: {
      passwordMismatch: 'Las contraseñas no coinciden',
      passwordTooShort: 'La contraseña debe tener al menos 6 caracteres',
      updateSuccess: 'Perfil actualizado correctamente',
      updateError: 'Error al actualizar el perfil',
    },
  },
  homepage: {
    title: 'Inicio',
    loading: 'Cargando...',
    stats: {
      totalEvents: 'Eventos Totales',
      participants: 'Participantes',
      locations: 'Ubicaciones',
      matches: 'Matches',
      totalClients: 'Clientes Totales',
      totalRevenue: 'Ingresos Totales',
      showRevenue: 'Mostrar ingresos',
      hideRevenue: 'Ocultar ingresos',
    },
    recentEvents: 'ESTADÍSTICAS ÚLTIMOS EVENTOS',
    upcomingEvents: 'PRÓXIMOS EVENTOS ITALIA',
    table: {
      eventName: 'Nombre del Evento',
      ageRange: 'Rango de Edad',
      date: 'Fecha',
      location: 'Ubicación',
      city: 'Ciudad',
      participants: 'Participantes',
      matches: 'Matches',
      menRevenue: 'Ingresos Hombres',
      womenRevenue: 'Ingresos Mujeres',
      total: 'Total',
      men: 'H: ',
      women: 'M: ',
    },
    noEvents: 'No hay eventos programados',
    eventStatus: {
      soldOut: 'AGOTADO + LISTA DE ESPERA',
      almostFull: 'CASI COMPLETO',
      limitedSpots: 'PLAZAS LIMITADAS',
      scheduled: 'PROGRAMADO',
    },
  },
  login: {
    brand: 'FlashCrush',
    email: 'Email',
    password: 'Contraseña',
    loggingIn: 'Iniciando sesión...',
    logIn: 'Iniciar Sesión',
    register: 'Registrarse',
    forgotPassword: '¿Olvidaste tu contraseña?',
    registrationTitle: 'Registro',
    registrationDescription: 'Crea una nueva cuenta para participar en los eventos.',
    fullName: 'Nombre Completo',
    registering: 'Registrando...',
    alreadyHaveAccount: '¿Ya tienes una cuenta? Inicia sesión',
    resetPasswordTitle: 'Recuperación de Contraseña',
    resetPasswordDescription: 'Introduce tu email para recibir las instrucciones de recuperación de contraseña.',
    sending: 'Enviando...',
    sendInstructions: 'Enviar instrucciones',
    backToLogin: 'Volver al login',
    resetEmailSent: 'Si la dirección de email existe, recibirás las instrucciones para restablecer tu contraseña.',
    errors: {
      invalidCredentials: 'Credenciales no válidas. Verifica email y contraseña e inténtalo de nuevo.',
      emailNotConfirmed: 'Email no confirmado. Revisa tu bandeja de entrada para el enlace de confirmación.',
      invalidEmailFormat: 'Formato de email no válido. Introduce una dirección de email válida.',
      genericLoginError: 'Se ha producido un error durante el acceso. Inténtalo de nuevo más tarde.',
      registrationError: 'Error durante el registro',
      resetPasswordError: 'Error durante la recuperación de la contraseña',
    },
  },
  auth: {
    pendingApproval: 'Tu cuenta está pendiente de aprobación por un administrador.',
    accountRejected: 'Tu cuenta ha sido rechazada. Contacta con el administrador para más información.',
    accountSuspended: 'Tu cuenta ha sido suspendida. Contacta con el administrador para más información.',
    registrationComplete: '¡Registro completado! Tu cuenta está pendiente de aprobación por un administrador. Recibirás una notificación cuando puedas acceder.',
  },
  common: {
    loading: 'Cargando...',
    error: 'Error',
    close: 'Cerrar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Añadir',
    search: 'Buscar',
    noResults: 'Sin resultados',
    back: 'Atrás',
    next: 'Siguiente',
    hiddenAmount: '••••• €',
  },
};
